import axios from 'axios'

export function setAuthHeader(token) {
    axios.defaults.headers.common['Authorization'] = token ? 'Bearer ' + token : ''
    axios.defaults.withCredentials = true
    axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
    //axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
}